import {
  DEFAULT_TRANSFER_ELIGIBILITY,
  type TransferEligibilityConfig,
} from '@shared/calls/transfer'

/** Runtime transfer config — override gates or hold music without touching shared defaults. */
export function getTransferEligibilityConfig(): TransferEligibilityConfig {
  const holdOverride = import.meta.env.VITE_CALL_HOLD_MUSIC_URL?.trim()
  if (!holdOverride) return DEFAULT_TRANSFER_ELIGIBILITY
  return {
    ...DEFAULT_TRANSFER_ELIGIBILITY,
    holdMusicUrl: holdOverride,
  }
}
